import { Save } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PulmonologySaveButton({ onClick, saving = false, disabled = false }) {
  const { t } = useTranslation("pulmonology");
  const handleClick = () => Promise.resolve(onClick?.()).catch(() => undefined);

  return (
    <button type="button" className="pulmo-primary-button" onClick={handleClick} disabled={disabled || saving}>
      <Save size={14} /> {t(saving ? "common.saving" : "common.save")}
    </button>
  );
}